import NameIcon from '../shared/NameIcon'
import type { PatientJson } from 'app/types/entities'

export default function PatientNameIcon({
  patient,
  heightClassName = `h-12`,
  widthClassname = `w-12`,
}: {
  patient?: PatientJson
  heightClassName?: string
  widthClassname?: string
}) {
  return (
    <NameIcon
      fullName={`${patient?.firstName?.[0]?.toLocaleUpperCase() || ``}${
        patient?.lastName?.[0]?.toLocaleUpperCase() || ``
      }`}
      heightClassName={heightClassName}
      widthClassName={widthClassname}
    />
  )
}
